







































import Vue, { PropType } from "vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import Rates from "@/components/Molecules/Rates/index.vue";
import Suffix from "@/components/Atoms/Typography/Suffix/index.vue";
import Body from "@/components/Atoms/Typography/Body/index.vue";
import { Data, Methods, Computed, Props } from "./types";
import { REVIEW_CATEGORY_MAP } from "@/helpers/event-experience-helper";
import { CompanyDetailReviewCategory } from "@/api/types";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "EventExperienceReviews",
  components: {
    Heading,
    Rates,
    Suffix,
    Body
  },
  props: {
    experienceReview: {
      type: Object as PropType<Props["experienceReview"]>,
      required: true
    },
    category: {
      type: String as PropType<Props["category"]>,
      required: true
    }
  },
  computed: {
    convertedReviews() {
      if (this.category === CompanyDetailReviewCategory.SEMINAR) {
        return [
          {
            genre: REVIEW_CATEGORY_MAP[this.category]["rating2"],
            rating: this.experienceReview["rating2"],
            text: this.experienceReview["detail2"]
          },
          {
            genre: REVIEW_CATEGORY_MAP[this.category]["rating1"],
            rating: this.experienceReview["rating1"],
            text: this.experienceReview["detail1"]
          },
          {
            genre: REVIEW_CATEGORY_MAP[this.category]["rating5"],
            rating: this.experienceReview["rating5"],
            text: this.experienceReview["detail5"]
          },
          {
            genre: REVIEW_CATEGORY_MAP[this.category]["rating3"],
            rating: this.experienceReview["rating3"],
            text: this.experienceReview["detail3"]
          },
          {
            genre: REVIEW_CATEGORY_MAP[this.category]["rating4"],
            rating: this.experienceReview["rating4"],
            text: this.experienceReview["detail4"]
          },
          {
            genre: REVIEW_CATEGORY_MAP[this.category]["rating6"],
            rating: this.experienceReview["rating6"],
            text: this.experienceReview["detail6"]
          }
        ];
      } else if (this.category === CompanyDetailReviewCategory.INTERN) {
        return [
          {
            genre: REVIEW_CATEGORY_MAP[this.category]["rating1"],
            rating: this.experienceReview["rating1"],
            text: this.experienceReview["detail1"]
          },
          {
            genre: REVIEW_CATEGORY_MAP[this.category]["rating2"],
            rating: this.experienceReview["rating2"],
            text: this.experienceReview["detail2"]
          },
          {
            genre: REVIEW_CATEGORY_MAP[this.category]["rating3"],
            rating: this.experienceReview["rating3"],
            text: this.experienceReview["detail3"]
          },
          {
            genre: REVIEW_CATEGORY_MAP[this.category]["rating5"],
            rating: this.experienceReview["rating5"],
            text: this.experienceReview["detail5"]
          },
          {
            genre: REVIEW_CATEGORY_MAP[this.category]["rating4"],
            rating: this.experienceReview["rating4"],
            text: this.experienceReview["detail4"]
          },
          {
            genre: REVIEW_CATEGORY_MAP[this.category]["rating6"],
            rating: this.experienceReview["rating6"],
            text: this.experienceReview["detail6"]
          }
        ];
      } else if (this.category === CompanyDetailReviewCategory.RECRUITMENT) {
        return [
          {
            genre: REVIEW_CATEGORY_MAP[this.category]["rating1"],
            rating: this.experienceReview["rating1"],
            text: this.experienceReview["detail1"]
          },
          {
            genre: REVIEW_CATEGORY_MAP[this.category]["rating2"],
            rating: this.experienceReview["rating2"],
            text: this.experienceReview["detail2"]
          },
          {
            genre: REVIEW_CATEGORY_MAP[this.category]["rating3"],
            rating: this.experienceReview["rating3"],
            text: this.experienceReview["detail3"]
          },
          {
            genre: REVIEW_CATEGORY_MAP[this.category]["rating4"],
            rating: this.experienceReview["rating4"],
            text: this.experienceReview["detail4"]
          },
          {
            genre: REVIEW_CATEGORY_MAP[this.category]["rating5"],
            rating: this.experienceReview["rating5"],
            text: this.experienceReview["detail5"]
          },
          {
            genre: REVIEW_CATEGORY_MAP[this.category]["rating6"],
            rating: this.experienceReview["rating6"],
            text: this.experienceReview["detail6"]
          }
        ];
      } else {
        return [];
      }
    }
  }
});
